const Cancel = function () {
  this.editRole.hideModal()
  this.editRole.resetEditRoleModal()
}

export default Cancel
